import { render } from "./HeaderRecorrencia.vue?vue&type=template&id=54ed541b&scoped=true"
import script from "./HeaderRecorrencia.vue?vue&type=script&lang=js"
export * from "./HeaderRecorrencia.vue?vue&type=script&lang=js"

import "./HeaderRecorrencia.vue?vue&type=style&index=0&id=54ed541b&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ed541b"]])

export default __exports__